import { Locale } from '../types';

export const formattedPrice = (
  price: number,
  { lang, currency }: Locale = {
    lang: 'ru-RU',
    currency: 'RUB'
  }
) => {
  return new Intl.NumberFormat(lang, {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(price);
};
